






import { computed, defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'SvgIcon',
  props: {
    svgName: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
    svgColor: {
      type: String,
      default: '',
    },
  },
  setup(props: any) {
    const iconName = computed(() => `#icon-${props.svgName}`);

    const svgClass = computed(() => (props.className ? `svg-icon ${props.className}` : 'svg-icon')).value;

    const colorCode = computed(() => `${props.svgColor}`);

    return {
      iconName,
      svgClass,
      colorCode,
    };
  },
});
